// Autogenerated by `pnpm version-file`. DO NOT EDIT
export var VERSION = '1.38.0';
//# sourceMappingURL=version.js.map